import {twJoin} from 'tailwind-merge'

import {ClpHeaderBarSkeleton} from './ClpHeaderBarSkeleton'
import {DocumentSkeleton} from './DocumentSkeleton'
import {ClpNavBarSkeleton} from './ClpNavBarSkeleton'

export const ClpSkeleton = () => {
  return (
    <div className={'sm:px-spacing-32'}>
      <ClpNavBarSkeleton />
      <div
        className={twJoin(
          'grid clp-toc-visible:grid-cols-[1152px_224px] lg:grid-cols-[224px_1152px_224px]',
          'mx-auto w-full max-w-section gap-x-spacing-80 clp-toc-visible:max-w-max',
        )}
      >
        <div className={'hidden lg:block'} />
        <div>
          <ClpHeaderBarSkeleton />
          <DocumentSkeleton/>
        </div>
        <div className={'hidden animate-pulse pt-spacing-120 clp-toc-visible:block'}>
          <div className={'my-spacing-16 mr-spacing-96 h-spacing-12 rounded-full bg-gray-300'}></div>
          <div className={'my-spacing-16 mr-spacing-32 h-spacing-12 rounded-full bg-gray-300'}></div>
          <div className={'my-spacing-16 mr-spacing-80 h-spacing-12 rounded-full bg-gray-300'}></div>
          <div className={'my-spacing-16 mr-spacing-64 h-spacing-12 rounded-full bg-gray-300'}></div>
        </div>
      </div>
    </div>
  )
}
